"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vssx = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const VssxSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M6.75 22.5h14.5a.75.75 0 0 0 .75-.75V2.25a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v19.5a.75.75 0 0 0 .75.75M6.5 2.25A.25.25 0 0 1 6.75 2h14.5a.25.25 0 0 1 .25.25v19.5a.25.25 0 0 1-.25.25H6.75a.25.25 0 0 1-.25-.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M21.25 2H6.75a.25.25 0 0 0-.25.25v19.5c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V2.25a.25.25 0 0 0-.25-.25"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#185ABD",
    d: "M12 7.5H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M7.2 14.035q.264.765.3.965c.035-.13.145-.475.34-1l1.405-4H10.5l-2.335 6H6.81L4.5 10h1.29z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#C8C6C4",
    fillRule: "evenodd",
    d: "M15.75 20.5h3.5a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 .75.75m-.25-6.75a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25zm.25-2.75h3.5a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 .75.75m-.25-6.75a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#C8C6C4",
    d: "M12.5 19.43v.32a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-.25H8v.25a.75.75 0 0 0 .75.75h3.5a.75.75 0 0 0 .75-.75v-.53a2 2 0 0 1-.5.21M8.5 6.5V4.25A.25.25 0 0 1 8.75 4h3.5a.25.25 0 0 1 .25.25v2.32q.265.069.5.21V4.25a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75V6.5z",
    opacity: 0.64
  })]
});
const Vssx = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: VssxSvg
}));
exports.Vssx = Vssx;